export enum PreviewExportContextType {
	SENTENCE_TEXT = '_sentence_text',
	VERBATIM_TEXT = '_verbatim_text',
	DOCUMENT_TEXT = '_document_text'
}

